import { ReactNode, useEffect } from "react";
import { datadogRum } from "@datadog/browser-rum";

import { USE_DATADOG } from "common/utils/datadog";

import { useClinic } from "client/clinics/hooks";

type ClientErrorReportingProviderProps = {
  children: ReactNode;
};

/** Ensures that we have set up needed context for error reporting based on state changes in the application */
const ClientErrorReportingProvider = ({ children }: ClientErrorReportingProviderProps) => {
  const clinic = useClinic();

  useEffect(() => {
    if (USE_DATADOG) {
      datadogRum.setGlobalContext({
        "clinic.id": clinic.id,
        "clinic_group.id": clinic.group.id,
      });
    }
  }, [clinic.id, clinic.group.id]);

  return <>{children}</>;
};

export default ClientErrorReportingProvider;
